<mat-card>
  <mat-card-title> Create Flight Log </mat-card-title>
  <mat-divider></mat-divider>
  <div *tdLoading="let flightLog; until: flightLog$ | async; type: 'circle'; color: 'accent'">
    <fl-flight-log-form *ngIf="flightLog" [flightLog]="flightLog"></fl-flight-log-form>
  </div>
</mat-card>
